import { Sites } from '@ps/platform-message-framework/common/Sites';
import React, { useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import useFirstRender from '@swf/core/hooks/useFirstRender';
import { select } from '@swf/core/store';

import SelectCitizenshipFlag from '../../../RMFCitizenship/components/SelectCitizenshipFlag/SelectCitizenshipFlag';

import DKFields from './components/DKFields/DKFields';
import ESFields from './components/ESFields/ESFields';
import GRFields from './components/GRFields/GRFields';
import GenericFields from './components/GenericFields/GenericFields';
import PTFields from './components/PTFields/PTFields';

const countryForm = (country: Sites) => {
  switch (country) {
    case Sites.POR:
      return <PTFields />;
    case Sites.SPA:
      return <ESFields />;
    case Sites.DEN:
      return <DKFields />;
    case Sites.GR:
      return <GRFields />;
    default:
      return <GenericFields />;
  }
};

interface Props {
  formVisible: boolean;
}

const Fields: React.FC<Props> = () => {
  const firstRender = useFirstRender();
  const form = useForm();
  const site = useSelector(select.cms.getSiteId);

  useEffect(() => {
    if (firstRender) return;
    form.change('docOtherTypeName');
    form.change('nationalDocumentNumber');

    const fieldsToReset = ['nationalDocumentNumber', 'docNumber', 'state', 'docType'];
    const registeredFields = form.getRegisteredFields();

    fieldsToReset.forEach((field) => {
      if (registeredFields.includes(field)) {
        form.resetFieldState(field);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <fieldset data-testid="identity-verification-form-fields">
      <SelectCitizenshipFlag />
      {countryForm(site)}
    </fieldset>
  );
};

export default Fields;
